import React from 'react';
import { colors } from '@styleseat/brand';

type ArrowsChevronRightIconProps = {
  width?: number;
  height?: number;
  color?: string;
  testID?: string;
} & React.SVGProps<SVGSVGElement>;

export const ArrowsChevronRightIcon = ({
  width = 24,
  height = 24,
  color = colors.blackInBlack,
  testID,
}: ArrowsChevronRightIconProps) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    data-testid={testID}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.5857 12L7.29285 4.70712L8.70706 3.29291L17.4142 12L8.70706 20.7071L7.29285 19.2929L14.5857 12Z"
      fill={color}
    />
  </svg>
);
